import React, { useRef } from 'react';
import { createPortal } from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';

import { useBlockScroll } from '../../hooks/useBlockScroll';

// TODO: this component is similar to .../component/modals/Modal.js - it should be merged in a single component

const Popup = (props) => {
  useBlockScroll(props.isOpen, props.shouldScroll);
  const ref = useRef(null);

  return createPortal(
    <CSSTransition
      classNames="modal-container"
      in={props.isOpen}
      mountOnEnter={true}
      unmountOnExit={true}
      appear={true}
      timeout={300}
    >
      <div 
        key="popup"
        className={classNames('modal-container')} 
        onClick={(e) => ref.current === e.target && props.onClickOverlay()}
      >
        <div ref={ref} className={classNames('popup-modal-container')}>
          {props.children}
        </div>
      </div>
    </CSSTransition>,
    document.body
  );
};

Popup.propTypes = {
  shouldScroll: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClickOverlay: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

Popup.defaultProps = {
  shouldScroll: true,
};

export { Popup };
